"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getSortedRoutes", {
    enumerable: true,
    get: function() {
        return _sortedRoutes.getSortedRoutes;
    }
});
Object.defineProperty(exports, "isDynamicRoute", {
    enumerable: true,
    get: function() {
        return _isDynamic.isDynamicRoute;
    }
});
var _sortedRoutes = require("./sorted-routes");
var _isDynamic = require("./is-dynamic");

//# sourceMappingURL=index.js.map